import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { images } from "../Images/Svg";
import { colors } from "../constants/colors";
const {
  welcomeTour,
  sidebarMenutour,
  invoiceTour,
  approvalTour,
  vendorTour,
  misTour,
  dashCase,
  dashAgeing,
  dashAction,
  caseTour,
} = images;

export const Step = [
  {
    content: <h2>Let's begin your app journey!</h2>,
    locale: { skip: <strong aria-label="skip">S-K-I-P</strong> },
    placement: "center",
    target: "body",
  },
  {
    title: "Welcome to CHASE!",
    content: (
      <>
        <Box>
          <Typography sx={{ fontSize: "15px" }}>
            Your personalised view on <b style={{ color: colors.red }}>CHASE</b>{" "}
            allows you to perform all tasks required to view and manage the
            investigation of cases
          </Typography>
        </Box>
        <Box>
          <img src={welcomeTour} alt="welcome to chase icon" />
        </Box>
      </>
    ),
    target: "#illustration",
    placement: "left",
    z: 1000,
  },
  {
    content: (
      <>
        <Box>
          <Typography sx={{ fontSize: "15px" }}>
            <b style={{ color: colors.red }}>Navigate</b> to your preferred
            section to perform your daily tasks
          </Typography>
        </Box>
        <Box>
          <img src={sidebarMenutour} alt="welcome to sidebar menu" />
        </Box>
      </>
    ),
    placement: "right",
    target: "#sidebar-menu",
  },
  {
    content: (
      <>
        <Box>
          <Typography sx={{ fontSize: "15px" }}>
            <b style={{ color: colors.red }}>Manage</b> all case investigation
            and statuses
          </Typography>
        </Box>
        <Box>
          <img src={caseTour} alt="welcome to sidebar menu" />
        </Box>
      </>
    ),
    placement: "right",
    target: "#sidebar-case-management",
  },
  {
    content: (
      <>
        <Box>
          <Typography sx={{ fontSize: "15px" }}>
            Add, edit and manage
            <b style={{ color: colors.red }}>Vendors</b>
          </Typography>
        </Box>
        <Box>
          <img src={vendorTour} alt="welcome to sidebar menu" />
        </Box>
      </>
    ),
    placement: "right",
    target: "#sidebar-vendor-management",
  },
  {
    content: (
      <>
        <Box>
          <Typography sx={{ fontSize: "15px" }}>
            View personalised dashboard and extract{" "}
            <b style={{ color: colors.red }}>reports</b>
          </Typography>
        </Box>
        <Box>
          <img src={misTour} alt="welcome to sidebar menu" />
        </Box>
      </>
    ),
    placement: "right",
    target: "#sidebar-reports",
  },
  {
    content: (
      <>
        <Box>
          <Typography sx={{ fontSize: "15px" }}>
            View status and Manage{" "}
            <b style={{ color: colors.red }}>approvals</b> for cases, invoices,
            recommendations and vendors
          </Typography>
        </Box>
        <Box>
          <img src={approvalTour} alt="welcome to sidebar menu" />
        </Box>
      </>
    ),
    placement: "right",
    target: "#sidebar-approval",
  },
  {
    content: (
      <>
        <Box>
          <Typography sx={{ fontSize: "15px" }}>
            View status of <b style={{ color: colors.red }}>invoices</b>
          </Typography>
        </Box>
        <Box>
          <img src={invoiceTour} alt="welcome to sidebar menu" />
        </Box>
      </>
    ),
    placement: "right",
    target: "#sidebar-invoice",
  },
  {
    content: (
      <>
        <Box>
          <Typography sx={{ fontSize: "15px" }}>
            Access <b style={{ color: colors.red }}>cases</b> by status
          </Typography>
        </Box>
        <Box>
          <img src={dashCase} alt="welcome to sidebar menu" />
        </Box>
      </>
    ),
    placement: "right",
    target: "#dash-case-management",
  },
  {
    content: (
      <>
        <Box>
          <Typography sx={{ fontSize: "15px" }}>
            View <b style={{ color: colors.red }}>personalised</b> ageing report
          </Typography>
        </Box>
        <Box>
          <img src={dashAgeing} alt="welcome to sidebar menu" />
        </Box>
      </>
    ),
    placement: "left",
    target: "#dash-ageing",
  },
  {
    content: (
      <>
        <Box>
          <Typography sx={{ fontSize: "15px" }}>
            View personalised <b style={{ color: colors.red }}>ageing</b> report
          </Typography>
        </Box>
        <Box>
          <img src={dashAction} alt="welcome to sidebar menu" />
        </Box>
      </>
    ),
    placement: "left",
    target: "#dash-action",
  },
];
